import { CheckCheck, ChevronDown, Settings } from 'lucide-react';
import { useNavigate } from 'react-router';

import { useNotificationsSheet } from '@/components/features/notifications/NotificationSheetProvider';
import { Button, ButtonGroup } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

interface NotificationsSheetActionsProps {
  makeAllVisibleNotificationsRead: () => void;
  makeAllNotificationsRead: () => void;
}

export default function NotificationsSheetActions(notificationsSheetActionsProps: NotificationsSheetActionsProps) {
  const { makeAllVisibleNotificationsRead, makeAllNotificationsRead } = notificationsSheetActionsProps;

  const { onOpenChange } = useNotificationsSheet();
  const navigate = useNavigate();

  const navigateNotificationSettings = () => {
    onOpenChange(false);
    navigate('/settings');
  };

  return (
    <ButtonGroup>
      <Button variant="outline" size="sm" onClick={makeAllVisibleNotificationsRead}>
        <CheckCheck />
        Oznacz widoczne
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm">
            <ChevronDown className="transition-all group-aria-expanded/button:rotate-180" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-full max-w-40">
          <DropdownMenuGroup>
            <DropdownMenuItem onClick={makeAllNotificationsRead}>
              <CheckCheck className={'size-4'} />
              Oznacz wszystkie
            </DropdownMenuItem>
            <DropdownMenuItem onClick={navigateNotificationSettings}>
              <Settings className={'size-4'} />
              Ustawienia powiadomień
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </ButtonGroup>
  );
}
